import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { CommissionComment } from 'types/embedded/commission';

export const getCommissionComments = async (id: number): Promise<CommissionComment[]> => {
  return axios
    .get(`commissions/${id}/comments`, {
      headers: { Accept: 'application/ld+json' },
    })
    .then((response: AxiosResponse) => response.data['hydra:member'])
    .catch((error: AxiosError) => Promise.reject(error.response));
};
